module.exports = __webpack_public_path__ + "img/six_zhCn.c0b4ede4.png";